import withScrollContainer from './enhancers/withScrollContainer';
import { SimpleTabsItemView, SimpleTabsListView } from './views';

/**
 * Tab View Group handling overflow via horizontal scroller
 * These tabs are not production ready, they still require context to function
 */
export const [ScrollableTabsListView, ScrollableTabsItemView] = withScrollContainer([
  SimpleTabsListView,
  SimpleTabsItemView,
]);
